import React from 'react';
// bulbal: ẩn nút "Đăng ký" — tài khoản chat chỉ tạo qua SSO HRM (auto-provision).
import { BULBAL_UI_SCOPE } from '../bulbal-config.js';

export default class MenuStart extends React.PureComponent {
  render() {
    return (
        <div>
          {BULBAL_UI_SCOPE.hideSignUp ? null :
          <>
            <a href="#" onClick={(e) => {e.preventDefault(); this.props.onSignUp();}}><i className="material-icons">person_add</i></a>
            &nbsp;
          </>}
          <a href="#" onClick={(e) => {e.preventDefault(); this.props.onSettings();}}><i className="material-icons">settings</i></a>
        </div>
    );
  }
};
